import JustValidate from 'just-validate';

const validate_form = new JustValidate('#form-reset-password');

validate_form
.addField('.input-email', [
    {
        rule: 'required',
        errorMessage: 'Email is required',
    },
    {
        rule: 'email',
        errorMessage: 'Email is invalid!',
    },
])
.onSuccess((event) => {
    document.getElementById('form-reset-password').submit()
});
